import React, { useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { Form } from 'react-bootstrap'
import MyEditor from '../../components/MyEditor'
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosInstance from '../../utils/axiosConfig';

function Replay() {
    const navigate = useNavigate();
    const [contact, setContact] = useState({})
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState("")
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/contact/${id}`)
                setContact(response.data.data)
            } catch (error) {
                if (error.response.data.status === 400) {
                    toast.error(error.response?.data?.message);
                }
                console.error(error.response?.data?.message || 'Internal server error');
                navigate('/contact');
            }
        }
        if (id) {
            fetchData()
        }
    }, [id, navigate])
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const responseData = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/admin/contact/respond/${id}`,
                { response }
            );
            toast.success(responseData.data.message);
            navigate('/contact');
        } catch (error) {
            if (error.response.data.status === 400) {
                toast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout title="Replay">
            <main>
                <div className="card page-card">
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-12 custom-modal">
                                <Form.Group controlId="email" className='d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2'>
                                    <Form.Label className='mb-0 replay-label'>Name:-</Form.Label>
                                    <p className='mb-0'>{contact.name ? contact.name : "-"}</p>
                                </Form.Group>
                            </div>
                            <div className="col-12 custom-modal">
                                <Form.Group controlId="email" className='d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2'>
                                    <Form.Label className='mb-0 replay-label'>Email:-</Form.Label>
                                    <p className='mb-0'>{contact.email ? contact.email : "-"}</p>
                                </Form.Group>
                            </div>
                            <div className="col-12 custom-modal">
                                <Form.Group controlId="email" className='d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2'>
                                    <Form.Label className='mb-0 replay-label'>Phone:-</Form.Label>
                                    <p className='mb-0'>{contact.phone ? contact.phone : "-"}</p>
                                </Form.Group>
                            </div>
                            <div className="col-12 custom-modal">
                                <Form.Group controlId="email" className='d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2'>
                                    <Form.Label className='mb-0 replay-label'>Message:-</Form.Label>
                                    <p className='mb-0'>{contact.message ? contact.message : "-"}</p>
                                </Form.Group>
                            </div>
                            <div className="col-12">
                                <Form.Group controlId="Password">
                                    <Form.Label>Replay</Form.Label>
                                </Form.Group>
                                <MyEditor
                                    htmlData={response}
                                    setCourseAdd={(content) => setResponse(content)}
                                />
                            </div>
                            <div className="col-12 d-flex justify-content-end gap-3">
                                <button
                                    className='btn-outline fs-16 fw-700 px-4'
                                    onClick={() => navigate('/contact')}
                                    type="button"
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    className='btn-primary fs-16 fw-700 px-4'
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? 'Sending...' : 'Send'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export default Replay